import React from 'react';
import {
  faCheckCircle,
  faCircleNotch,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SubdomainStatusAdornment = ({ loading, available, error }) => {
  if (loading) {
    return (
      <FontAwesomeIcon icon={faCircleNotch} spin />
    );
  }
  if (error) {
    return (
      <FontAwesomeIcon icon={faTimesCircle} color="#DC2626" />
    );
  }
  if (available !== null) {
    return (
      <FontAwesomeIcon
        icon={available ? faCheckCircle : faTimesCircle}
        color={available ? '#22C55E' : '#DC2626'}
      />
    );
  }
  return null;
};

export default SubdomainStatusAdornment;